define('views/content/payments',['require','views/base/list_page_view','views/components/manual_payment/manual_payments','collections/manual_payments','text!templates/content/payments.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ManualPaymentsView = require('views/components/manual_payment/manual_payments');
    var ManualPaymentsCollection = require('collections/manual_payments');

    var temp = require("text!templates/content/payments.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'payments-page',
        titleKey: 'payments',

        setCollection: function () {
            this.collection = new ManualPaymentsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new ManualPaymentsView({
                collection: this.collection
            }));
        }

    });
});
